/**
 * Clausula de diagnóstico (R/C, M/P, justificación). Label uppercase
 * coloreado + contenido. Sin caja, sin background, sin borde lateral en
 * variant 'plain'. La distinción semántica vive en el color del label.
 *
 * @param {Object} props
 * @param {string} props.label  Texto del label (ej. "Relacionado con").
 * @param {'attention'|'stable'|'critical'|'pending'|'brand'} props.tone
 * @param {'plain'|'pull-quote'} [props.variant='plain']
 *   `pull-quote` aplica border-left + Fraunces italic en el contenido.
 *   Uso exclusivo: razonamiento clínico.
 * @param {React.ReactNode} props.children
 */
export default function DxClause({
  label,
  tone,
  variant = 'plain',
  children,
}) {
  const labelToneClass = TONE_TO_CLASS[tone] || 'text-ink';

  if (variant === 'pull-quote') {
    // text-reasoning es el token canónico de la "voz que enseña" (Fraunces
    // italic 15px/1.6, tokens-v1 §tipografía): el contrato de componentes lo
    // prometía aquí desde el inicio y el código usaba text-body a mano.
    return (
      <div className="border-l-2 border-brand pl-3">
        <p className={`text-micro ${labelToneClass} mb-1.5`}>{label}</p>
        <div className="font-serif italic text-reasoning text-ink">
          {children}
        </div>
      </div>
    );
  }

  return (
    <div>
      <p className={`text-micro ${labelToneClass} mb-1.5`}>{label}</p>
      <div className="text-body text-ink font-sans">{children}</div>
    </div>
  );
}

const TONE_TO_CLASS = {
  attention: 'text-clinical-attention',
  stable: 'text-clinical-stable',
  critical: 'text-clinical-critical',
  pending: 'text-clinical-pending',
  brand: 'text-brand',
};
